import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { TopRightCloseButton } from "@src/appV2/redesign/components/TopRightCloseButton";
import { Pill, Text } from "@src/appV2/redesign/system/ui-components";

import graduationCapImage from "./assets/images/graduationCap.png";
import { SCHOLARSHIP_BANNER_GRADIENT } from "./constants";

interface ScholarshipBannerProps {
  onClick: () => void;
  onDismiss: () => void;
}

export function ScholarshipBanner(props: ScholarshipBannerProps) {
  const { onClick, onDismiss } = props;

  return (
    <Box sx={{ position: "relative" }}>
      <TopRightCloseButton
        onClick={() => {
          onDismiss();
        }}
      />
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.borderRadius?.medium,
          background: SCHOLARSHIP_BANNER_GRADIENT,
          height: "100%",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          component="img"
          src={graduationCapImage}
          alt="Graduation Cap"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "80%",
            maxHeight: 160,
            aspectRatio: "1 / 1",
            objectFit: "contain",
            pointerEvents: "none",
            transform: "translate(15%, 5%)",
          }}
        />
        <Pill label="New" size="small" sx={{ alignSelf: "flex-start", position: "relative" }} />
        <Stack
          gap={5}
          sx={{ flex: 1, justifyContent: "space-between", marginTop: 2, position: "relative" }}
        >
          <Stack gap={3}>
            <Text bold variant="h4">
              15% Off Tuition
            </Text>
            <Text
              variant="body2"
              sx={{ color: (theme) => theme.palette.text.secondary, maxWidth: "60%" }}
            >
              Get 15% off tuition at Concorde Career College by working shifts.
            </Text>
          </Stack>
          <Button
            variant="contained"
            size="small"
            sx={{ alignSelf: "flex-start" }}
            onClick={onClick}
          >
            Learn more
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
